import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { BrowserRouter } from 'react-router-dom';

import { history } from "./helpers/history";

const theme = createTheme({
  palette: {
    primary: {
       light: '#ed4b82',
      main: '#e91e63',
       dark: '#a31545',
      // contrastText: will be calculated to contrast with palette.primary.main
    }
    ,
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});
ReactDOM.render(
  <React.StrictMode>
    
   
    <ThemeProvider theme={theme}>
    <BrowserRouter basename="/regs-lnwf" >
    <App />
    </BrowserRouter>
    </ThemeProvider>
    
    
  
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
